module.exports = __webpack_public_path__ + "assets/location-pin.59496044.svg";